module.exports = __webpack_public_path__ + "assets/woman.0f38212b.svg";